<div class="setting-section">
  <app-user-mngt-detail [customers]="customers" (userSaved)="onUserSaved($event)"></app-user-mngt-detail>

  <div class="fc-mngt-toolbar">
    <h2 class="fc-mngt-title">Users</h2>
    <div class="fc-mngt-search">
      <span class="material-icons fc-mngt-search-icon">search</span>
      <input class="fc-mngt-search-input" type="text" placeholder="Filter users…" (keyup)="doFilter($any($event.target).value)" />
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" class="usersTable" matSort>
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
      <td mat-cell *matCellDef="let element">{{ element.username }}</td>
    </ng-container>
    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef>Customer</th>
      <td mat-cell *matCellDef="let element">{{ element.customerName }}</td>
    </ng-container>
    <ng-container matColumnDef="enabled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [checked]="element.enabled" disabled="true"></mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Unit</th>
      <td mat-cell *matCellDef="let element">{{ element.unit }}</td>
    </ng-container>
    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef>Roles</th>
      <td mat-cell *matCellDef="let element">
        <mat-chip-list>
          <mat-chip *ngFor="let role of element.roles" class="roleInChip">{{ role }}</mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="actionButtonCol">
        <button class="fc-action-btn" (click)="edit(element)">Edit</button>
        <button class="fc-action-btn" (click)="generatePwdConfirmDialog(element)" title="Generate and send new password">Gen. Pwd</button>
        <button class="fc-action-btn fc-action-btn--danger" (click)="deleteConfirmDialog(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell fc-no-data" colspan="7">No users found</td>
    </tr>
  </table>
</div>
